import React, {useEffect, useState, Fragment} from 'react';
import Layout from 'components/sales/layout/layout';
import {Button} from "react-bootstrap";
import TableSection from 'components/sales/tableSection/tableSection';
import Images from 'assets/images/imageData';
import {toast} from "react-toastify";
import { Link } from 'react-router-dom';
import localization from 'assets/localization/localization';
import ModalPop from 'components/sales/modal/modal';
import ConstantInput from 'components/sales/Input/constantInput/constantInput';

const FinanceIncentive = (
    {
        match,
        history,
        getIncentiveListForFinanceApproval,
        incentiveListFinance,
        acceptApproval,
        rejectApproval,
    }
) => {
    const [isLoading, setIsLoading] = useState(false);
    const [listData, setListData] = useState();
    const [pageCount, setPageCount] = useState(0);
    const [isModal, setIsModal] = useState(false);
    const [actionData, setActionData] = useState();
    const [isSuccessModel, setIsSuccessModel] = useState(false);
    const handleModalHide = () => setIsModal(false);
    const [remark, setRemark] = useState("");
    const headers = [
        'Site No',
        'Site Name',
        'Incentive For',
        'Incentive Amount',
        'User',
        'User Incetive(%)',
        'User Incentive Amount',
        'Senior',
        'Senior Incentive(%)',
        'Senior Incentive Amount',
        'Head',
        'Head Incentive(%)',
        'Head Incentive Amount',
        'Created By',
        'Sales Status',
        'Sales Approval Date',
        'Finance Status',
        'Finance Remark',
        'Created',
        'Approve/Reject',
        //'Action',
    ];

    useEffect(() => {
        (async () => {
            setIsLoading(true)
            getIncentiveListForFinanceApproval(1);
            setIsLoading(false)
        })()
    }, []);

    useEffect(() => {
        const tableData = [
            'id',
            'site_no',
            'site_name',
            'incentive_for',
            'incentive_amount',
            'user_name',
            'user_incentive_percentage',
            'user_incentive',
            'senior_name',
            'senior_incentive_percentage',
            'senior_incentive',
            'head_name',
            'head_incentive_percentage',
            'head_incentive',
            'created_by_user',
            'sales_status',
            'sales_approval_date',
            'finance_status',
            'finance_remark',
            'created_at',
            'Approve/Reject',
            //'Action'
        ];

        if (incentiveListFinance && incentiveListFinance?.data &&incentiveListFinance?.data.length > 0) { 
            const data = incentiveListFinance.data.map((element) =>
                Object.assign(
                    {},
                    ...tableData.map((key) => ( 
                        (key === 'sales_status' && element['sales_status'] === 1) ? 
                        {[key]: 'Approved'} : (key === 'Approve/Reject' && (element['finance_status'] === 2 || element['finance_status'] === 1)) ? 
                        {[key]: 'No'} : (key === 'sales_status' && element['sales_status'] === 0) ? 
                        {[key]: 'Pending'} : (key === 'finance_status' && element['finance_status'] === 0) ? 
                        {[key]: 'Pending'} : (key === 'finance_status' && element['finance_status'] === 1) ? 
                        {[key]: 'Approved'} : (key === 'finance_status' && element['finance_status'] === 2) ? 
                        {[key]: 'Rejected'} : (key === 'finance_status' && element['finance_status'] === 3) ? 
                        {[key]: 'Hold'} : (key === 'user_name' && element['user_name'] === null) ? 
                        {[key]: 'NA'} : (key === 'senior_name' && element['senior_name'] === null) ? 
                        {[key]: 'NA'} : (key === 'head_name' && element['head_name'] === null) ? 
                        {[key]: 'NA'} : (key === 'created_by_user' && element['created_by_user'] === null) ? 
                        {[key]: 'Auto'} : {[key]: element[key]}           
                        )
                    ),
                )
            );  
            data && setListData(data);
            setPageCount(Math.ceil(incentiveListFinance.total / incentiveListFinance.per_page));
        }
    }, [incentiveListFinance]);

    const onPageChange = async (val) => {
      setIsLoading(true);
      await getIncentiveListForFinanceApproval(val.selected + 1);
      setIsLoading(false);
    };

    //console.log(listData);
    const updateApproval = async (data) => {
        setActionData(data);
        if (data.action === 'accept') {
          const requestData = {
            id: data.actionObj.id,
            actionFor: 'Accept',
            status: 1
          }; 
          setIsLoading(true);
          await acceptApproval(requestData).then(async (response) => {
            if (response) {
              await getIncentiveListForFinanceApproval(null, 1);
              setIsLoading(false);
              setIsModal(true);
            }else{
              setIsLoading(false);
            }
          });
        } else {
          setIsModal(true);
          setIsLoading(false);
        }
      };

      const handleContinue = async () => {
        setIsModal(false);
        const requestData = {
          id: actionData.actionObj.id,
          remarks: remark,
          actionFor: 'Reject',
          status: 2
        };
        setIsLoading(true);
        await rejectApproval(requestData).then(async (response) => {
          setIsLoading(false);
          if (response) {
            await getIncentiveListForFinanceApproval(null, 1);
            setIsSuccessModel(true);
          }
        });
      };  

      const successIconBox = (text, func) => {
        return (
          <div className="text-center">
            <div className="success">
              <img src={Images?.tick} alt="" />
            </div>
            <h5>{text}</h5>
            <Link to="#" onClick={func} className="btn btn-transparent">
              {localization.returnToIncentive}{' '}
              <img src={Images?.ArrowRight} alt="" />
            </Link>
          </div>
        );
      };
    
   

    return (
        <Layout
            title={localization.salesApprovedIncentiveList}
            isLoading={isLoading}
            //isGoback={true}
        > 
        <>
        <div className="container-fluid">
        <div className="card mt-2">
        <div className="card-header">
                {localization.incentiveList}
        </div>
            <div className="card-header">
            <div className="card-body">
            <TableSection
                    data={listData}
                    isId={false}
                    isMngId={false}
                    headers={headers}
                    pageCount={pageCount}
                    onPageChange={onPageChange}
                    onChange={(data) => {updateApproval(data)}}
                    //detailList={listData && listData}
                    srNo={incentiveListFinance?.data?.from}
            />
            </div>
            </div>
        </div>
        </div>

        <ModalPop
                title={
                actionData && actionData.action === 'reject'
                    ? localization.rejectConf
                    : localization.conf
                }
                show={isModal}
                handleModalHide={handleModalHide}
                actionData={actionData}
            >
            {actionData && actionData.action === 'reject' ? (
            <Fragment>
                <div className="modal-body">
                <div className="text-center">
                    <h5>{localization.rejectIncentive}</h5>
                    <div className="form-group">
                    <ConstantInput
                        label={localization.addRemark}
                        required
                        isStarRequired={true}
                        type="text"
                        handleChange={(val) => {
                        setRemark(val);
                        }}
                    />
                    </div>
                    <Button
                    className="btn btn-primary"
                    onClick={handleContinue}
                    disabled={!remark}
                    >
                    {localization.continue}{' '}
                    <img src="../images/arrow-right.png" alt="" />
                    </Button>
                </div>
                </div>
            </Fragment>
            ) : (
            <Fragment>
                {successIconBox(localization.approveIncentiveScccess, handleModalHide)}
            </Fragment>
            )}
            </ModalPop>
        </>
        </Layout>
    )
}

export default FinanceIncentive;